import React from 'react';
import PropTypes from 'prop-types';
import FormattedMessageMarkdown from 'components/FormattedMessageMarkdown';
import useColorType from 'components/hooks/useColorType';

const Privacy = () => {
  const colorType = useColorType('privacy');

  return (
    <FormattedMessageMarkdown
      colorType={colorType}
      id="certilogo.privacy"
      defaultMessage="Privacy"
    />
  );
};

Privacy.propTypes = {
  colorType: PropTypes.string,
  children: PropTypes.node,
};

export default Privacy;
